import React, { PropTypes } from 'react'
import { List, ListItem } from 'material-ui/List'
import Toggle from 'material-ui/Toggle'
import map from 'lodash/map'

const Editor = ({ value, onChange }) => {
  const handleToggle = (event, object, key, item) => {
    object[key] = !item
    onChange(event, value)
  }

  const listItems = object => {
    return map(object, (item, key) => {
      if (typeof item === 'boolean') {
        const toggle = <Toggle toggled={item} onToggle={e => handleToggle(e, object, key, item)} />
        return (
          <ListItem key={key} primaryText={key} rightToggle={toggle} />
        )
      } else {
        return <ListItem key={key} primaryText={key} nestedItems={listItems(item)} />
      }
    })
  }

  return (
    <List>{listItems(value)}</List>
  )
}

// @ts-ignore
Editor.propTypes = {
  value: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired
}

// @ts-ignore
Editor.defaultProps = {
  value: { }
}

export default Editor
